<bricks-modal (closeDialog)="closeDialog()">
  <bricks-modal-header>Haben Sie Anspruch auf EEG-Förderung?</bricks-modal-header>
  <bricks-modal-body>
    <div class="flex-row">
      <div class="flex-col-50">
        <b>EEG-Direktvermarktung nach dem Marktprämienmodell (gefördert)</b>
        <ul>
          <li>Für EEG-Anlagen ab 100 kW Leistung, die noch innerhalb der 20-jährigen EEG-Förderung liegen</li>
          <li>
            Für Anlagen (ab 1 MW) die den Zuschlag für den anzulegenden Wert im Ausschreibungsverfahren (BNetzA)
            erhalten haben
          </li>
        </ul>
        <p class="highlight highlight-positive">Ja, ich habe Anspruch auf EEG-Förderung</p>
      </div>
      <div class="flex-col-50">
        <b>Sonstige Direktvermarktung (ungefördert sowie Post-EEG)</b>
        <ul>
          <li>Für EEG-Anlagen, deren 20-jährige EEG-Förderung bereits abgelaufen ist (Post-EEG)</li>
          <li>Für Anlagen, deren Standort nicht EEG-Förderbar sind</li>
          <li>Für Anlagen (ab 1MW) die <b>nicht</b> an dem Ausschreibungsverfahren teilgenommen haben.</li>
        </ul>
        <p class="highlight highlight-negative">Nein, ich habe keinen Anspruch auf EEG-Förderung</p>
      </div>
    </div>
    <p>
      Als zusätzliche Hilfestellung finden Sie
      <a
        href="https://www.interconnector.de/energieblog/so-finden-sie-die-richtige-direktvermarktungsform-fuer-ihre-anlage/"
        target="_blank"
        >HIER</a
      >
      eine ausführliche Erklärung der verschiedenen Vermarktungsformen. Wenn Sie sich nicht sicher sind, welche
      Vermarktungsform für Ihre Anlage gilt, wenden Sie sich bitte vor der Angebotserstellung an Ihren
      Verteilnetzbetreiber.
    </p>
  </bricks-modal-body>
  <bricks-modal-footer>
    <button class="bricks-button button-primary button-fn" (click)="closeDialog()">
      <span>Zur Kenntnis genommen</span>
    </button>
  </bricks-modal-footer>
</bricks-modal>
